import Cookies from 'js-cookie'

export const initUserSearchResultsViewType = location => {
  return (dispatch, getState) => {
    // if there is view parameter for initial rendering, set view type to cookie
    if (location && location.query.view) {
      dispatch(setUserSearchResultsViewType(location.query.view))
    } else {
      dispatch(
        getUserSearchResultsViewType(
          getState().user.preferences.searchResultsViewType
        )
      )
    }
  }
}

export const initServerUserSearchResultsViewType = location => {
  return (dispatch, getState) => {
    // if there is view parameter for initial rendering, set view type to cookie
    if (location && location.query.view) {
      dispatch(setServerUserSearchResultsViewType(location.query.view))
    }
  }
}

export const getUserSearchResultsViewType = defaultView => {
  let view = Cookies.get('search-view-mode-preference') || defaultView
  return { type: 'getUserSearchResultsViewType', payload: { view } }
}

export const setUserSearchResultsViewType = nextView => {
  Cookies.set('search-view-mode-preference', nextView)
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const setServerUserSearchResultsViewType = nextView => {
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const getUserVideoPlayerStatus = () => {
  const key = 'search_videos_muted'
  if (window.localStorage && window.localStorage.getItem(key)) {
    return {
      type: 'getUserVideoPlayerStatus',
      payload: {
        type: window.localStorage.getItem(key) === 'true'
      }
    }
  } else {
    return {
      type: 'nullAction'
    }
  }
}

export const setUserVideoPlayerStatus = type => {
  if (window.localStorage) {
    const key = 'search_videos_muted'
    window.localStorage.setItem(key, type)
    return { type: 'setUserVideoPlayerStatus', payload: { type } }
  } else {
    return {
      type: 'nullAction'
    }
  }
}



// WEBPACK FOOTER //
// ./common/actions/user/preference.js